import Vue from "vue"
import Vapi from "vuex-rest-api"

const instruments = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    instrument: null,
    instruments: [],
    allInstruments: [],
  },
})

  // instruments
  .get({
    action: "retrieveInstrument",
    property: "instrument",
    path: ({ id }) => `/instruments/${id}/`,
  })
  .get({
    action: "listInstruments",
    property: "instruments",
    path: "/instruments/",
  })
  .get({
    action: "listAllInstruments",
    property: "allInstruments",
    path: "/instruments/?no_page=1",
  })
  .post({
    action: "createInstrument",
    property: "instrument",
    path: "/instruments/",
  })
  .patch({
    action: "updateInstrument",
    property: "instrument",
    path: ({ id }) => `/instruments/${id}/`,
  })
  .delete({
    action: "destroyInstrument",
    path: ({ id }) => `/instruments/${id}/`,
  })

  // finalize
  .getStore()

export default instruments
